import i18n from "@i18n/i18n";
import { Alert, Box, Card, Container, Grid, Typography } from "@mui/material";
import { observer } from "mobx-react";
import MaterialGrid from "./MaterialGrid";
import RunJobButton from "@components/SustainabilityJobs/RunJobButton";
import useAppStore from "@hooks/useAppStore";
import { FeatureManagementType } from "@api/apiClient";

const MaterialsPage = observer(() => {
  const appStore = useAppStore();

  return (
    <Container maxWidth={false} sx={{ height: "100%" }}>
      <Grid mt={2} container spacing={2} sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Grid size={12} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexGrow: 0 }}>
          <Typography variant="h6" fontWeight="bold">
            {i18n.t("materials-page.title")}
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2, ml: 1 }}>
            {appStore.hasFeature(FeatureManagementType.SDADataSyncVisibility) && appStore.sustainabilitySyncInProgress && (
              <Alert severity="info" variant="filled" sx={{ py: 0.5, flex: 1, maxWidth: 480 }}>
                {appStore.sustainabilitySyncMessage}
              </Alert>
            )}
            {appStore.hasFeature(FeatureManagementType.SDADataSyncVisibility) && (
              <RunJobButton />
            )}
          </Box>
        </Grid>
        <Grid size={12} sx={{ display: "flex", flexGrow: 0 }}>
          <Card elevation={3}></Card>
        </Grid>
        <Grid size={12} sx={{ display: "flex", flexGrow: 1, width: "100%", position: "relative" }}>
          <MaterialGrid />
        </Grid>
      </Grid>
    </Container>
  );
});

export default MaterialsPage;
